// NOTE: NSAI-7001 — the one tab look the app uses, taken from the AI Call
// Assistant switcher: a neutral `switcher-track` with the active tab lifted
// onto a brand `switcher-thumb` pill (NSAI-6259 set the colours) that SLIDES
// to the tab you pick rather than jumping to it. Both the Radix `ui/tabs`
// primitive and the controlled `components/Tabs` switcher read these, so a tab
// row cannot drift back to a second idiom.
//
// The pill is one element (`TabsIndicator`) travelling behind the row, so the
// triggers carry no active background of their own — only the text colour,
// keyed on `data-state="active"`, which Radix sets itself and the controlled
// switcher sets by hand.
export const TABS_LIST_CLASS_NAME =
  "relative inline-flex h-10 items-center justify-center rounded-lg bg-switcher-track p-1 text-foreground-secondary";

export const TABS_TRIGGER_CLASS_NAME =
  "relative z-10 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-background transition-colors duration-200 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-switcher-thumb-foreground";

export const TABS_INDICATOR_CLASS_NAME =
  "pointer-events-none absolute left-0 top-0 z-0 rounded-md bg-switcher-thumb shadow-sm";

// NOTE: Same motion as the Call Assistant pill; dropped entirely under
// prefers-reduced-motion.
export const TABS_INDICATOR_TRANSITION_CLASS_NAME =
  "transition-[transform,width,height] duration-300 ease-out motion-reduce:transition-none";

// NOTE: How each primitive marks its active tab — Radix with ARIA, the
// controlled switcher with the `data-active` flag its specs already read.
export const RADIX_ACTIVE_TAB_SELECTOR = '[role="tab"][aria-selected="true"]';

export const CONTROLLED_ACTIVE_TAB_SELECTOR = '[data-active="true"]';
